import { ColorKeys } from "@/theme/colors";
import { Avatar } from "../Avatar";
import "./CardUser.scss";
import { Col, Row } from "@/components";
import { HeadingLevel } from "@/types/headings";

type CardUserProps = {
  titleTag?: HeadingLevel;
  userName: string;
  avatar?: {
    initials: string;
    bg?: ColorKeys;
    textColor?: ColorKeys;
  };
  information?: {
    label: string;
    value: string;
  }[];
};

export const CardUser = ({
  titleTag: TitleTag = "h1",
  userName,
  avatar,
  information = [],
}: CardUserProps) => {
  return (
    <Col
      as={"article"}
      bg={"white"}
      br={"x4"}
      p={"x16"}
      gap={"x16"}
      className="shadow md-p-x24 md-gap-x24"
    >
      <Row as={"header"} gap={"x16"} alignItems={"center"}>
        {avatar && (
          <Avatar
            textColor={avatar?.textColor ?? "slate-20"}
            bg={avatar?.bg ?? "lightblue-a01"}
            initials={avatar?.initials ?? ""}
            className="ui-card-doctor-avatar"
            size="3"
          />
        )}
        <TitleTag className="fs-5 fw-semibold text-slate-20">
          {userName}
        </TitleTag>
      </Row>
      <dl className="ui-card-user ">
        {information.map(({ label, value }) => (
          <div key={label}>
            <dt className="fs-6 fw-bold text-slate-28">{label}</dt>
            <dd className="fs-6 fw-regular text-slate-28">{value}</dd>
          </div>
        ))}
      </dl>
    </Col>
  );
};
